module.exports = __webpack_public_path__ + "media/icons/opony-felgi-baner@2x-2b46dfea.png";